let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6eD1Y")).then(() => parcelRequire('1YlyW'));